var map = {
	"./template.bet575": 1709,
	"./template.bet575.tsx": 1709,
	"./template.bet777": 1710,
	"./template.bet777.tsx": 1710,
	"./template.betbetbet": 1711,
	"./template.betbetbet.tsx": 1711,
	"./template.betblast": 1712,
	"./template.betblast.tsx": 1712,
	"./template.betprofessor": 1713,
	"./template.betprofessor.tsx": 1713,
	"./template.betroyale": 1714,
	"./template.betroyale.tsx": 1714,
	"./template.betstride": 1715,
	"./template.betstride.tsx": 1715,
	"./template.buffalobet": 1975,
	"./template.buffalobet.tsx": 1975,
	"./template.chromabet": 1716,
	"./template.chromabet.tsx": 1716,
	"./template.default": 671,
	"./template.default.tsx": 671,
	"./template.fiestabet": 1717,
	"./template.fiestabet.tsx": 1717,
	"./template.forsport": 1718,
	"./template.forsport.tsx": 1718,
	"./template.gigabet": 1719,
	"./template.gigabet.tsx": 1719,
	"./template.goldenbet888": 1720,
	"./template.goldenbet888.tsx": 1720,
	"./template.goldenrush": 1721,
	"./template.goldenrush.tsx": 1721,
	"./template.hyperbet": 1722,
	"./template.hyperbet.tsx": 1722,
	"./template.juicybet": 1723,
	"./template.juicybet.tsx": 1723,
	"./template.junglebet": 1724,
	"./template.junglebet.tsx": 1724,
	"./template.magnumbet": 1725,
	"./template.magnumbet.tsx": 1725,
	"./template.oldgill": 1726,
	"./template.oldgill.tsx": 1726,
	"./template.puntcity": 1727,
	"./template.puntcity.tsx": 1727,
	"./template.puntgenie": 1728,
	"./template.puntgenie.tsx": 1728,
	"./template.pyramidbet": 1729,
	"./template.pyramidbet.tsx": 1729,
	"./template.questbet": 1730,
	"./template.questbet.tsx": 1730,
	"./template.slambet": 1731,
	"./template.slambet.tsx": 1731,
	"./template.sterlingparker": 1732,
	"./template.sterlingparker.tsx": 1732,
	"./template.sugarcastle": 1733,
	"./template.sugarcastle.tsx": 1733,
	"./template.templebet": 1734,
	"./template.templebet.tsx": 1734,
	"./template.titanbet": 1737,
	"./template.titanbet.tsx": 1737,
	"./template.ts": 985,
	"./template.vikingbet": 1738,
	"./template.vikingbet.tsx": 1738,
	"./template.volcanobet": 1739,
	"./template.volcanobet.tsx": 1739,
	"./template.wellbet": 1740,
	"./template.wellbet.tsx": 1740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2468;